<template>
  <div class="absolute inset-0 flex-c h-full">
    <component
      :is="component"
      :post="media"
      :tour-group="media.children"
    />

    <RouterLink
      :to="{ name: 'content' }"
      class="absolute top-0 right-0 flex bg-black text-white text-xxl font-normal p-3 md:p-6 lg:px-6 lg:py-6 xxl:px-10 xxl:py-10  focus-b z-10"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" v-bind:svg-inline="''" v-bind:class="'h-6 w-6 fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="none" stroke="#fff" stroke-width="5.88" d="M29.921 29.921L2.079 2.079M29.921 2.079L2.079 29.921"/></svg>
      <span
        v-show="!mobile"
        class="ml-3"
      >
        Close
      </span>
    </RouterLink>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Panorama from '@/components/Panorama.vue'
import Video from '@/components/Video.vue'
import { loadKrp } from '@/mixins'

export default {
  name: 'Media',

  mixins: [ loadKrp ],

  components: {
    Panorama,
    Video
  },

  computed: {
    ...mapState([ 'touch', 'mobile' ]),
    ...mapGetters([ 'post', 'getMediaBySlug' ]),

    media() {
      return this.getMediaBySlug(this.$route.params.media_id)
    },

    component() {
      return this.media.type === 'video' ? 'Video' : 'Panorama'
    }
  },

  created() {
    window.addEventListener('keyup', () => {
      if (event.code === 'Escape') {
        this.$router.push({ name: 'content' })
      }
    })
  }
}
</script>
